import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'Shopping-Cart-Top-eSpot_rv' }
];
export default contentItems;